import { render, staticRenderFns } from "./MarathonDetailCard.vue?vue&type=template&id=62b4d176&scoped=true&"
import script from "./MarathonDetailCard.vue?vue&type=script&lang=js&"
export * from "./MarathonDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./MarathonDetailCard.vue?vue&type=style&index=0&id=62b4d176&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b4d176",
  null
  
)

export default component.exports